import {
  Illustration as LeelooIllustration,
  IllustrationProps as LeelooIllustrationProps,
} from "@leeloo/core";

export const Illustration = (props: LeelooIllustrationProps) => {
  return <LeelooIllustration {...props} />;
};
